import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { Store } from '@ngxs/store';

import { PAGES } from 'src/modules/shared/constants/pages';
import { RecoverPasswordData } from 'src/modules/shared/models/reset-password.model';
import { RecoverPassword } from 'src/modules/shared/ngxs/authentication/authentication.actions';
import { REGEX } from 'src/modules/shared/regular-expressions';
import { RouterService } from 'src/modules/shared/services/router.service';
import { ShowNotificationsService } from 'src/modules/shared/services/show-notifications.service';
import { confirmPasswordValidator } from 'src/modules/shared/validators/confirm-password.validation';

@Component({
  selector: 'rs-reset-password',
  templateUrl: 'reset-password.component.html',
  styleUrls: ['reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  public resetPasswordForm: FormGroup;

  private token: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private routerService: RouterService,
    private store: Store,
    private showNotificationsService: ShowNotificationsService
  ) {}

  ngOnInit() {
    this.getResetToken();
    this.initForm();
  }

  public resetPassword(): void {
    if (this.resetPasswordForm.valid) {
      const { password } = this.resetPasswordForm.getRawValue();

      this.store.dispatch(new RecoverPassword(new RecoverPasswordData(password, this.token)));
    }
  }

  private getResetToken(): void {
    this.token = this.route.snapshot.queryParams.token;

    if (!this.token) {
      this.showNotificationsService.showPasswordLinkIsIncorrect();
      this.routerService.navigateToPage(PAGES.SIGN_IN);
    }
  }

  private initForm(): void {
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.pattern(REGEX.PASSWORD)]],
      confirm: ['', Validators.required]
    }, {
      validators: confirmPasswordValidator
    });
  }

}
